import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import {
	SetProductListByIntegration,
	SetNexsysAttributeList,
	SetAppScopeDocumentTypes,
	SetAcuityDocumentTypes,
	SetGenericIntegrations,
	SetAcuityMilestones,
	SetCmpAcuityMilestones,
	SetCmpAcuityDocumentTypes,
	SetClassValuationDocTypes,
	SetAppScopeAssetOnCompletion,
	SetAcuityAssetOnCompletion,
	SetSchemaList
} from '../../state/actions/global-configuration.actions';
import { INTEGRATIONS } from '../../model/global-configuration.constant';
import { SetInspectionTypes, SetLastUpdate, SetOrigins, SetProductTypes } from '../../state/actions/global-configuration-enums.actions';
import { GlobalConfigurationEnumsState } from '../../state/global-configuration-enums.state';

@Injectable({
	providedIn: 'root'
})
export class ProductsLoaderService implements CanActivate {
	constructor(private store: Store) {
	}

	/**
	 * Load all util lists for lender routes.
	 * @param childRoute
	 * @param state
	 */
	canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
		// eslint-disable-next-line no-async-promise-executor
		return new Promise(async resolve => {
			const now = Date.now();
			const lastUpdate = this.store.selectSnapshot(GlobalConfigurationEnumsState.getLastUpdate) || 0;
			const diff = (now - lastUpdate) / 1000;

			if (diff > 600 || lastUpdate === 0) {
				await this.store.dispatch(new SetOrigins()).toPromise();
				await this.store.dispatch(new SetProductListByIntegration(INTEGRATIONS.ACUITY)).toPromise();
				await this.store.dispatch(new SetProductListByIntegration(INTEGRATIONS.APPSCOPE)).toPromise();
				await this.store.dispatch(new SetProductListByIntegration(INTEGRATIONS.CMP_ACUTIY)).toPromise();
				await this.store.dispatch(new SetAcuityMilestones()).toPromise();
				await this.store.dispatch(new SetCmpAcuityMilestones()).toPromise();

				await this.store.dispatch(new SetProductListByIntegration(INTEGRATIONS.NEXSYS)).toPromise();
				await this.store.dispatch(new SetProductListByIntegration(INTEGRATIONS.VALUTRUST)).toPromise();
				await this.store.dispatch(new SetNexsysAttributeList()).toPromise();
				await this.store.dispatch(new SetProductListByIntegration(INTEGRATIONS.INSIDEMAPS)).toPromise();
				await this.store.dispatch(new SetProductListByIntegration(INTEGRATIONS.XPANSE)).toPromise();
				await this.store.dispatch(new SetProductListByIntegration(INTEGRATIONS.FNC)).toPromise();

				await this.store.dispatch(new SetGenericIntegrations()).toPromise();
				await this.store.dispatch(new SetAppScopeDocumentTypes()).toPromise();
				await this.store.dispatch(new SetAcuityDocumentTypes()).toPromise();
				await this.store.dispatch(new SetCmpAcuityDocumentTypes()).toPromise();
				await this.store.dispatch(new SetClassValuationDocTypes()).toPromise();

				await this.store.dispatch(new SetAppScopeAssetOnCompletion()).toPromise();
				await this.store.dispatch(new SetAcuityAssetOnCompletion()).toPromise();

				await this.store.dispatch(new SetSchemaList()).toPromise();
				await this.store.dispatch(new SetProductTypes()).toPromise();
				await this.store.dispatch(new SetInspectionTypes()).toPromise();

				await this.store.dispatch(new SetLastUpdate()).toPromise();
			}
			resolve(true);
		});
	}
}
